"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PreKeyAuth = (function () {
    function PreKeyAuth() {
    }
    PreKeyAuth.INVALID = 'Invalid';
    PreKeyAuth.UNKNOWN = 'Unknown';
    PreKeyAuth.VALID = 'Valid';
    return PreKeyAuth;
}());
exports.default = PreKeyAuth;



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/keys/PreKeyAuth.js
// module id = 109
// module chunks = 0 1